import { CrudService, EntityProps } from '@awp/shared/CrudService';
import React from 'react';
import { isValueEmpty } from '@awp/helpers/utilsReact';

export default class RoadClosureLocationsService extends CrudService {
  constructor(mode: string) {
    const entityName = 'Road Closure Location';
    const entityPluralName = 'Road Closure Locations';

    super({ entityName, entityPluralName, mode });
  }

  getActionMenu(event: any): React.ReactElement {
    return <></>;
  }

  getColumns(props: any): any {
    /* Do Nothing */
  }

  getFields(props: any): React.ReactElement {
    return <></>;
  }

  getValidations(props?: any): any {
    /* Do Nothing */
  }

  mapFormToDTO(props: any): any {
    /* Do Nothing */
  }

  mapInitialValues(props: any): any {
    const { entity, area, avalanchePrograms, ...rest } = props;

    return {
      program: avalanchePrograms.find((x: any) => x.value === area.parentId),
      area: area ?? null,
      name: entity.name ?? '',
      description: entity.description ?? '',
      longitude: entity.longitude?.toString() ?? '',
      latitude: entity.latitude?.toString() ?? '',
      active: isValueEmpty(entity.isDisabled) ? false : !entity.isDisabled,
    };
  }

  cleanFormValues(props: EntityProps): any {
    /* Do Nothing */
  }
}
